// src/modules/FRPModule/FRPSearchBar.tsx
import { SearchBarGeneral, SearchBarGeneralContext, SearchBarGeneralPlugin, SearchBarGeneralPluginSuggestion } from "../../components/SearchBarGeneral";
import { useContext } from "react";
import { FRPState, FRPContext } from "./FRPState";
import { AbstractAutocompletePlugin } from "src/managers/SearchBarGeneralPlugin";
import { ActionTracker } from "src/common/managers/ActionTracker";

class FRPElementAutoComplete extends AbstractAutocompletePlugin implements SearchBarGeneralPlugin {
   private frpState: FRPState;

   constructor(frpState: FRPState, onSelection?: (data: any) => void) {
      super("Element", { key: "Element" }, 3, 30, 100, "Element", onSelection);
      this.frpState = frpState;
   }

   async calculateSuggestions(context: SearchBarGeneralContext, queryString: string): Promise<SearchBarGeneralPluginSuggestion[]> {
      let results: SearchBarGeneralPluginSuggestion[] = [];
      let alreadyFound: string[] = [];

      for (let element of Object.values(this.frpState.elements)) {
         // Search in element name, content, or other searchable fields
         const searchableText = [
            element.name,
            element.id,
            element.type
         ].join(' ').toLowerCase();

         if (searchableText.includes(queryString.toLowerCase())) {
            if (!alreadyFound.includes(element.id)) {
               results.push({
                  betegnelse: element.name || element.id,
                  code: element.id,
                  name: element.name || element.id,
                  data: element,
                  onSelection: this.onSelection
               });
               alreadyFound.push(element.id);
            }
         }
      }

      return results;
   }
}

export const FRPSearchBar = (props: { callbackOnSelect: (element: any) => void }) => {
   const { state: frpState } = useContext(FRPContext);

   return (
      <SearchBarGeneral
         showWindow={true}
         autocompleters={[
            new FRPElementAutoComplete(frpState, (data: any) => {
               ActionTracker.track("FRPModule", "Search", "FRPElement");
               props.callbackOnSelect(data);
            })
         ]}
         callbackOnSelection={(type: string, selectionProps: any) => {
            props.callbackOnSelect(selectionProps);
         }}
      />
   );
};

